export default "__VITE_ASSET__BhrhyLG7__"